export function money(value: number | string | null | undefined) {
  return Number(value ?? 0).toLocaleString("zh-TW");
}

export function shortDate(value?: string | null) {
  if (!value) return "-";
  return new Date(value).toLocaleString("zh-TW", { hour12: false });
}
